import { z } from "zod";
import { DateValidation } from "../shared/date-validation";

export const BusinessUnitLicenseItemSchema = z.object({
  // Core identification
  Id: z.string().uuid(),
  Name: z.string().optional(),

  // Business Unit reference
  BusinessUnitId: z.string().uuid().optional(),
  BusinessUnitName: z.string().optional(),

  // Product information (SaaS/License)
  ProductId: z.string().uuid().optional(),
  ProductName: z.string().optional(),

  // Purchase reference
  PurchasedProductId: z.string().uuid().optional(),

  // Sales order information
  SalesOrderId: z.string().uuid().optional(),

  // License lifecycle dates
  DateSold: DateValidation,
  DatePaid: DateValidation,
  DateStarted: DateValidation, // When license activation started
  DateStopped: DateValidation, // When license ends/expires
  DateCancelled: DateValidation,
  Created: DateValidation,

  // Status information
  StateCode: z.number().optional(),
  StatusCode: z.number().optional(),
  ProductStatusCode: z.number().optional(),
  ProductStatusName: z.string().optional(),

  // License specific information
  LicenseKey: z.string().optional(),
  LicenseKeyStatus: z.string().optional(),

  // Activation and assignment
  ActivatedById: z.string().uuid().optional(),
  ActivatedByName: z.string().optional(),
  ContactId: z.string().uuid().optional(),

  // Quantity and inventory
  Quantity: z.number().optional(),

  // Financial information
  IsPaid: z.boolean().optional(),
  PaidStatusCode: z.number().optional(),
  InvoiceCreated: z.boolean().optional(),
  InvoiceSent: z.boolean().optional(),
  TaxAmount: z.number().optional(),
  BaseAmount: z.number().optional(),
  ExtendedAmount: z.number().optional(),
  ListPrice: z.number().optional(),
  ManualDiscountAmount: z.number().optional(),
  PricePerUnitAmount: z.number().optional(),
  SalesPrice: z.number().optional(),

  // Service License Agreement
  ServiceLicenseAgreementId: z.string().uuid().optional(),

  // Additional metadata
  Description: z.string().optional(),
  Unit: z.string().optional(),
  PackageCount: z.number().optional(),
  LineItemNumber: z.number().optional(),
  LineTypeCode: z.number().optional(),
  SalesChannelCode: z.number().optional(),

  // Trial and portal flags
  IsTrialOffer: z.boolean().optional(),
  IsPortal: z.boolean().optional(),
  IsDeleted: z.boolean().optional(),

  // Cancellation
  ReasonForCancellationCode: z.number().optional(),
  ReasonForCancellationNotes: z.string().optional(),

  // References to other entities
  CurrencyId: z.string().uuid().optional(),
  UnitOfMeasureId: z.string().uuid().optional(),
  PriceListId: z.string().uuid().optional(),
  InvoiceLineItemId: z.string().uuid().optional(),

  // Cloud integration
  PetrosoftCloudId: z.string().optional(),

  // Installation status (for software licenses)
  Installed: z.boolean().optional(),
});

export type BusinessUnitLicenseItemType = z.infer<
  typeof BusinessUnitLicenseItemSchema
>;
